import { Alert, Typography } from '@mui/material';
import { isApiError } from '../../api/errors';
import { errorViewFor } from '../error-states';

/**
 * Inline error of a failed action (submit, resend, email change). The „Fehler-ID“ is only shown
 * for technical errors (§66).
 */
export function ActionError({ error }: { error: unknown }) {
  const view = errorViewFor(error);
  const requestId = view.showRequestId && isApiError(error) ? error.requestId : null;
  return (
    <Alert severity="error" role="alert">
      {view.message}
      {requestId ? (
        <Typography variant="body2" component="p" sx={{ mt: 1 }}>
          Fehler-ID: <code>{requestId}</code>
        </Typography>
      ) : null}
    </Alert>
  );
}
